import { render, staticRenderFns } from "./Mileage.vue?vue&type=template&id=ed1b1b4c&scoped=true&"
import script from "./Mileage.vue?vue&type=script&lang=js&"
export * from "./Mileage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b1b4c",
  null
  
)

export default component.exports